import { TOAST_NOTIFICATION_TEMPLATES } from '../constants/toastNotificationTemplates';

export const getToastNotificationData = (type, notificationData) => {
  const template = TOAST_NOTIFICATION_TEMPLATES[type];

  const message = getMessage(template.message, notificationData);
  const url = getUrl(template.url, notificationData);

  return { message, url, state: notificationData.state, storeField: template.storeField };
};

const getMessage = (templateMessage, notificationData) => {
  let message = templateMessage;
  for (const key in notificationData) {
    message = message.replace(`{${key}}`, notificationData[key]);
  }

  return message;
};

const getUrl = (templateUrl, notificationData) => {
  if (!templateUrl) {
    return;
  }

  let url = templateUrl;
  for (const key in notificationData) {
    url = url.replace(`{${key}}`, notificationData[key]);
  }

  return url;
};
